/**
 * Programmatically triggers a link click by creating a temporary anchor element.
 * Useful for triggering click tracking when navigating via JavaScript.
 *
 * @param {string} url - The URL to navigate to
 * @param {Object.<string, string>} [attributes={}] - Optional attributes to set on the anchor (e.g., data-* for tracking)
 *
 * @example
 * // Simple navigation
 * triggerLinkClick('/some/path');
 *
 * @example
 * // With attributes
 * triggerLinkClick('/products', {
 *     'element': 'content cards',
 *     'target': '_blank'
 * });
 */
export function triggerLinkClick(url, attributes = {}) {
    const a = document.createElement('a');
    a.href = url;
    a.style.display = 'none';
    a.classList.add('visuallyhidden');

    Object.entries(attributes).forEach(([key, value]) => {
        a.setAttribute(key, value);
    });

    document.body.appendChild(a);
    a.click();
    a.remove();
}
